import { render, staticRenderFns } from "./send-skinny-down.vue?vue&type=template&id=47db7c9c&"
import script from "./send-skinny-down.vue?vue&type=script&lang=js&"
export * from "./send-skinny-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47db7c9c')) {
      api.createRecord('47db7c9c', component.options)
    } else {
      api.reload('47db7c9c', component.options)
    }
    module.hot.accept("./send-skinny-down.vue?vue&type=template&id=47db7c9c&", function () {
      api.rerender('47db7c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/send-skinny-down.vue"
export default component.exports